import "./About.module.css";
import MainNavigation from "@/reusable_sections/Header";
import ThePowerOfBranding from "./sections/ThePowerOfBranding";
import InnovationsAndTechnology from "./sections/InnovationsAndTechnology";
import StrategicLeads from "./sections/StrategicLeads";
import Footer from "@/reusable_sections/Footer";
export default function AboutPage() {
  return <div>
      <MainNavigation />
      <ThePowerOfBranding />
      <InnovationsAndTechnology />
      <StrategicLeads />
      <Footer />
    </div>;
}